module.exports = __webpack_public_path__ + "media/application/images/svgs/delete-1621c5355e6684097902e2a491ddd468.svg";